"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tag = _interopRequireDefault(require("../Dropdown/Tag"));

var _Base = _interopRequireDefault(require("../Input/Base"));

var _InputWrapper = _interopRequireDefault(require("../InputWrapper"));

var _Validate = require("../Validate");

var _lib = require("../../lib");

var _common = require("../../common");

var _constants = require("../../constants");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputMultiple =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputMultiple, _PureComponent);

  function InputMultiple(props) {
    var _this;

    _classCallCheck(this, InputMultiple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputMultiple).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getFinalRawValue", function () {
      var value = _this.state.value;
      var separator = _this.props.separator;

      if ((0, _lib.arrayHasItems)(value)) {
        return value.map(function (v) {
          return v.value;
        }).join(separator);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getNewValue", function (e, rawValue) {
      var rawValueArr = _this.splitRawValue(rawValue);

      var _this$state = _this.state,
          value = _this$state.value,
          key = _this$state.key;
      var newValue = [].concat(value);
      rawValueArr.forEach(function (v, idx) {
        return newValue.push({
          value: v,
          key: key + idx
        });
      });
      return newValue;
    });

    _defineProperty(_assertThisInitialized(_this), "getFirstRawValue", function (e, rawValue) {
      var rawValueArr = _this.splitRawValue(rawValue);

      var newRawValue = '';

      if ((0, _lib.arrayHasItems)(rawValueArr)) {
        var firstRawValue = rawValueArr[0];

        if (firstRawValue) {
          newRawValue = firstRawValue;
        }
      }

      return newRawValue;
    });

    _defineProperty(_assertThisInitialized(_this), "getLastRawValue", function (e, rawValue) {
      var rawValueArr = _this.splitRawValue(rawValue);

      var newRawValue = '';

      if ((0, _lib.arrayHasItems)(rawValueArr)) {
        var lastRawValue = rawValueArr[rawValueArr.length - 1];

        if (lastRawValue) {
          newRawValue = lastRawValue;
        }
      }

      return newRawValue;
    });

    _defineProperty(_assertThisInitialized(_this), "getOutputData", function () {
      var value = _this.state.value;
      var name = _this.props.name;

      var finalRawValue = _this.getFinalRawValue();

      return {
        name: name,
        value: value.map(function (v) {
          return v.value;
        }),
        rawValue: finalRawValue
      };
    });

    _defineProperty(_assertThisInitialized(_this), "splitRawValue", function () {
      var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var regex = InputMultiple.getRegex(_this.props);
      return rawValue.split(regex).map(function (v) {
        return v.trim();
      }).filter(function (v) {
        return v;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "highlightText", function () {
      var current = _this.innerRef.current;
      var rawValue = _this.state.rawValue;

      if (current && rawValue) {
        current.select();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "callOnChange", function (e) {
      var onChange = _this.props.onChange;

      var data = _this.getOutputData();

      if (onChange) {
        onChange(e, data);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "callOnDelete", function (e, value) {
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(e, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "callOnAdd", function (e, value) {
      var onAdd = _this.props.onAdd;

      if (onAdd) {
        onAdd(e, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function (e) {
      var disabled = _this.props.disabled; // fix safari focus bug when multiple Input components inside Label component

      (0, _lib.callEventMethods)(e, 'preventDefault');

      if (disabled) {
        return;
      }

      if (_this.innerRef && _this.innerRef.current) {
        _this.innerRef.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isSeparatorIncluded", function (rawValue) {
      var regex = InputMultiple.getRegex(_this.props);

      if (rawValue) {
        return rawValue.match(regex);
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var rawValue = _ref.value;

      // setState rawValue to ensure onChange trigger for Input base
      _this.setState({
        rawValue: rawValue
      }, function () {
        if (_this.isSeparatorIncluded(rawValue)) {
          var rawValueArr = _this.splitRawValue(rawValue);

          var newValue = _this.getNewValue(e, rawValue);

          _this.setState(function (prevState) {
            return {
              key: prevState.key + rawValueArr.length,
              rawValue: '',
              value: newValue
            };
          }, function () {
            _this.callOnChange(e);

            rawValueArr.forEach(function (v) {
              return _this.callOnAdd(e, v);
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDelete", function (e, _ref2) {
      var v = _ref2.value,
          key = _ref2.key;
      (0, _lib.callEventMethods)(e, 'preventDefault');
      var value = _this.state.value;

      if (value) {
        var index = value.findIndex(function (val) {
          return val.key === key;
        });

        if (index > -1) {
          var newValue = [].concat(value);
          newValue.splice(index, 1);

          _this.setState({
            value: newValue
          }, function () {
            _this.callOnChange(e);

            _this.callOnDelete(e, v);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnKeyDown", function (e) {
      var keyCode = e.keyCode;

      switch (keyCode) {
        case _constants.KEY_BACK_SPACE:
          _this.handleOnBackSpace(e);

          break;

        case _constants.KEY_ENTER:
          _this.handleOnEnter(e);

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBackSpace", function (e) {
      var current = _this.innerRef.current;
      var value = _this.state.value;

      if (current && current.value < 1 && (0, _lib.arrayHasItems)(value)) {
        var newValue = [].concat(value);
        var index = value.length - 1;
        var rawValue = value[index].value;
        newValue.splice(index, 1); // prevent delete last character

        (0, _lib.callEventMethods)(e, 'preventDefault');

        _this.setState({
          rawValue: rawValue,
          value: newValue
        }, function () {
          _this.highlightText();

          _this.callOnChange(e);

          _this.callOnDelete(e, rawValue);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEnter", function (e) {
      var rawValue = _this.state.rawValue;
      var newRawValue = rawValue.trim();

      if ((0, _lib.numberHasLength)(newRawValue.length)) {
        var newValue = _this.getNewValue(e, newRawValue);

        _this.setState(function (prevState) {
          return {
            key: prevState.key + 1,
            rawValue: '',
            value: newValue
          };
        }, function () {
          _this.callOnChange(e);

          _this.callOnAdd(e, newRawValue);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (e) {
      var disabled = _this.props.disabled;
      (0, _lib.callEventMethods)(e, 'persist');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        focus: true
      }, function () {
        var onFocus = _this.props.onFocus;

        if (onFocus) {
          var data = _this.getOutputData();

          onFocus(e, data);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (e) {
      var disabled = _this.props.disabled;
      (0, _lib.callEventMethods)(e, 'persist');

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var rawValue = _this.state.rawValue;
      var newRawValue = rawValue.trim();

      if ((0, _lib.numberHasLength)(newRawValue.length)) {
        var newValue = _this.getNewValue(e, newRawValue);

        _this.setState(function (prevState) {
          return {
            key: prevState.key + 1,
            focus: false,
            rawValue: '',
            value: newValue
          };
        }, function () {
          _this.callOnChange(e);

          _this.callOnAdd(e, newRawValue);

          var onBlur = _this.props.onBlur;

          if (onBlur) {
            var data = _this.getOutputData();

            onBlur(e, data);
          }
        });
      } else {
        // reset to empty if not valid
        _this.setState({
          focus: false,
          rawValue: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTags", function () {
      var value = _this.state.value;

      if ((0, _lib.arrayHasItems)(value)) {
        return value.map(function (item) {
          return _react.default.createElement(_Tag.default, {
            key: item.key,
            text: item.value,
            onClick: _this.focus,
            onDelete: function onDelete(e) {
              return _this.handleOnDelete(e, item);
            }
          });
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function () {
      var _this$props = _this.props,
          name = _this$props.name,
          innerRef = _this$props.innerRef,
          placeholder = _this$props.placeholder;
      var _this$state2 = _this.state,
          value = _this$state2.value,
          rawValue = _this$state2.rawValue;
      var inputRef = innerRef || _this.innerRef;
      return _react.default.createElement(_Base.default, {
        name: name,
        innerRef: inputRef,
        value: rawValue,
        placeholder: !(0, _lib.arrayHasItems)(value) ? placeholder : null,
        onChange: _this.handleOnChange,
        onKeyDown: _this.handleOnKeyDown,
        onFocus: _this.handleOnFocus,
        onBlur: _this.handleOnBlur
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [InputMultiple.className];
      return names.join(' ');
    });

    var _value = props.value,
        _rawValue = props.rawValue;

    var _newValue = InputMultiple.getValue(props);

    var _key = InputMultiple.getCurrentKey(_newValue);

    _this.state = {
      focus: false,
      prevProps: {
        value: _value,
        rawValue: _rawValue
      },
      value: _newValue,
      rawValue: '',
      key: _key
    };
    _this.innerRef = _react.default.createRef();
    return _this;
  }

  _createClass(InputMultiple, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          placeholder = _this$props2.placeholder,
          propsValue = _this$props2.value,
          propsRawValue = _this$props2.rawValue,
          separator = _this$props2.separator,
          innerRef = _this$props2.innerRef,
          onAdd = _this$props2.onAdd,
          onDelete = _this$props2.onDelete,
          rest = _objectWithoutProperties(_this$props2, ["name", "onChange", "onClick", "placeholder", "value", "rawValue", "separator", "innerRef", "onAdd", "onDelete"]);

      var focus = this.state.focus;
      var classNames = this.classNames();
      return _react.default.createElement(_InputWrapper.default, _extends({}, rest, {
        // as div to prevent clicking wrapper deletes tag
        as: "div",
        focus: focus,
        onClick: this.focus,
        className: classNames
      }), this.renderTags(), this.renderInput());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          rawValue = props.rawValue;
      var newValue = InputMultiple.getValue(props);
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          rawValue: rawValue
        },
        key: prevProps.value !== value ? state.key + newValue.length : state.key,
        value: prevProps.value !== value ? newValue : state.value,
        rawValue: prevProps.rawValue !== rawValue ? '' : state.rawValue
      };
    }
  }]);

  return InputMultiple;
}(_react.PureComponent);

exports.default = InputMultiple;

_defineProperty(InputMultiple, "className", 'MHub-Input-Multiple');

_defineProperty(InputMultiple, "Validate", (0, _Validate.withValidate)(InputMultiple));

_defineProperty(InputMultiple, "propTypes", {
  name: _propTypes.default.string,
  value: _propTypes.default.arrayOf(_common.customPropTypes.stringOrNumber),
  rawValue: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onAdd: _propTypes.default.func,
  onDelete: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  separator: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  innerRef: _common.customPropTypes.ref,
  disabled: _propTypes.default.bool
});

_defineProperty(InputMultiple, "defaultProps", {
  name: null,
  value: [],
  rawValue: undefined,
  placeholder: null,
  onChange: null,
  onAdd: null,
  onDelete: null,
  onClick: null,
  onFocus: null,
  onBlur: null,
  separator: [';', ','],
  innerRef: null,
  disabled: false
});

_defineProperty(InputMultiple, "getValue", function (props) {
  var value = props.value,
      rawValue = props.rawValue;
  var newValue = [];

  if (rawValue) {
    var regex = InputMultiple.getRegex(props);
    newValue = rawValue.split(regex).map(function (v, idx) {
      return {
        value: v.trim(),
        key: idx
      };
    });
  }

  if (value && (0, _lib.arrayHasItems)(value)) {
    newValue = value.map(function (v, idx) {
      return {
        value: v.trim(),
        key: idx
      };
    });
  }

  return newValue;
});

_defineProperty(InputMultiple, "getRegex", function (props) {
  var separator = props.separator;
  var regex = new RegExp(separator);

  if ((0, _lib.isArray)(separator) && (0, _lib.arrayHasItems)(separator)) {
    regex = new RegExp(separator.join('|'));
  }

  return regex;
});

_defineProperty(InputMultiple, "getCurrentKey", function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lib.arrayHasItems)(value) ? value.length : 0;
});